<template>
    <div></div>
</template>

<script>
    export default {
        name: "inviteConf"
    }
</script>

<style scoped>

</style>